export default function replaceRtcId(str, callback) {
    let result = '';
    const idReg = /rtc:\/{2}[\d\w-]+(?=，)/g;
    result = str.replace(idReg, callback);
    return result;
}
